import type { Dispatch } from 'redux';
import type { CartType, FulfillmentType } from '~/utils/types';

export const RESET_MENU_ITEM_CART_DATA = 'RESET_MENU_ITEM_CART_DATA';
export const SET_MENU_ITEM_CART_BYPASS_PROMPT = 'SET_MENU_ITEM_CART_BYPASS_PROMPT';
export const SET_MENU_ITEM_CART_IS_SCHEDULED = 'SET_MENU_ITEM_CART_IS_SCHEDULED';
export const SET_MENU_ITEM_CART_LOCATION_ID = 'SET_MENU_ITEM_CART_LOCATION_ID';
export const SET_MENU_ITEM_CART_SCHEDULED_AT = 'SET_MENU_ITEM_CART_SCHEDULED_AT';
export const SET_MENU_ITEM_CART_TYPE = 'SET_MENU_ITEM_CART_TYPE';
export const SET_MENU_ITEM_CART_SPECIAL_INSTRUCTIONS_MAX_LENGTH = 'SET_MENU_ITEM_CART_SPECIAL_INSTRUCTIONS_MAX_LENGTH';
export const SET_MENU_ITEM_CART_FULFILLMENT_TYPE = 'SET_MENU_ITEM_CART_FULFILLMENT_TYPE';
export const SET_MENU_ITEM_CART_ID = 'SET_MENU_ITEM_CART_ID';
export const SET_SELECTED_MENU_ITEM = 'SET_SELECTED_MENU_ITEM';
export const SET_SELECTED_SECTION_INDEX = 'SET_SELECTED_SECTION_INDEX';
export const SET_SELECTED_SECTION_OFFSET = 'SET_SELECTED_SECTION_OFFSET';
export const SET_FOCUS_FIRST_SECTION_ITEM_EFFECT = 'SET_FOCUS_FIRST_SECTION_ITEM_EFFECT';
export const SET_SELECTED_SECTION_SLUG = 'SET_SELECTED_SECTION_SLUG';
export const SET_SHOULD_PRELOAD_SECTIONS = 'SET_SHOULD_PRELOAD_SECTIONS';

export interface MenuItem {
  menuId: Optional<number>;
  menuSectionId: Optional<number>;
}

export type MenuItemCartAction =
  { type: typeof RESET_MENU_ITEM_CART_DATA } |
  { type: typeof SET_MENU_ITEM_CART_BYPASS_PROMPT, bypassPrompt: boolean } |
  { type: typeof SET_MENU_ITEM_CART_IS_SCHEDULED, menuItemCartIsScheduled: boolean } |
  { type: typeof SET_MENU_ITEM_CART_LOCATION_ID, menuItemCartLocationId: Optional<number> } |
  { type: typeof SET_MENU_ITEM_CART_SCHEDULED_AT, menuItemCartScheduledAt: unknown } |
  { type: typeof SET_MENU_ITEM_CART_TYPE, menuItemCartType: Optional<CartType> } |
  { type: typeof SET_MENU_ITEM_CART_SPECIAL_INSTRUCTIONS_MAX_LENGTH, menuItemCartSpecialInstructionsMaxLength: Optional<number> } |
  { type: typeof SET_MENU_ITEM_CART_FULFILLMENT_TYPE, menuItemCartFulfillmentType: Optional<FulfillmentType> } |
  { type: typeof SET_MENU_ITEM_CART_ID, menuItemCartId: Optional<number> } |
  { type: typeof SET_SELECTED_MENU_ITEM, selectedMenuItem: Optional<MenuItem> } |
  { type: typeof SET_SELECTED_SECTION_INDEX, selectedSectionIndex: number } |
  { type: typeof SET_SELECTED_SECTION_OFFSET, selectedSectionOffset: number } |
  { type: typeof SET_SELECTED_SECTION_SLUG, selectedSectionSlug: Optional<string> } |
  { type: typeof SET_SHOULD_PRELOAD_SECTIONS, shouldPreloadSections: boolean } |
  { type: typeof SET_FOCUS_FIRST_SECTION_ITEM_EFFECT, status: 'active' | 'standby' }

// TODO: make this an alias for the argument type instead. Currently needed to decrease diff.
type DispatchMIC = (dispatch: Dispatch<MenuItemCartAction>) => void;

export function setMenuItemCartBypassPrompt(bypassPrompt: boolean): DispatchMIC {
  return (dispatch) => {
    dispatch({ bypassPrompt, type: SET_MENU_ITEM_CART_BYPASS_PROMPT });
  };
}

export function setMenuItemCartIsScheduled(menuItemCartIsScheduled: boolean): DispatchMIC {
  return (dispatch) => {
    dispatch({ menuItemCartIsScheduled, type: SET_MENU_ITEM_CART_IS_SCHEDULED });
  };
}

export function setMenuItemCartLocationId(menuItemCartLocationId: Optional<number>): DispatchMIC {
  return (dispatch) => {
    dispatch({ menuItemCartLocationId, type: SET_MENU_ITEM_CART_LOCATION_ID });
  };
}

export function setSelectedMenuItem(selectedMenuItem: Optional<MenuItem>): DispatchMIC {
  return (dispatch) => {
    dispatch({ selectedMenuItem, type: SET_SELECTED_MENU_ITEM });
  };
}

export function setSelectedSectionIndex(selectedSectionIndex: number): DispatchMIC {
  return (dispatch) => {
    dispatch({ selectedSectionIndex, type: SET_SELECTED_SECTION_INDEX });
  };
}

export function setSelectedSectionOffset(selectedSectionOffset: number): DispatchMIC {
  return (dispatch) => {
    dispatch({ selectedSectionOffset, type: SET_SELECTED_SECTION_OFFSET });
  };
}

export function setFocusFirstSectionItemEffect(status: 'active' | 'standby'): DispatchMIC {
  return (dispatch) => {
    dispatch({ status, type: SET_FOCUS_FIRST_SECTION_ITEM_EFFECT });
  };
}

export function setSelectedSectionSlug(selectedSectionSlug: Optional<string>): DispatchMIC {
  return (dispatch) => {
    dispatch({ selectedSectionSlug, type: SET_SELECTED_SECTION_SLUG });
  };
}

export function setShouldPreloadSections(shouldPreloadSections: boolean): DispatchMIC {
  return (dispatch) => {
    dispatch({ shouldPreloadSections, type: SET_SHOULD_PRELOAD_SECTIONS });
  };
}
